import { Display2DProperty } from './../image3d/image3d.component';
import { EntityDragEvent } from './../../ng3/controls/mouse/mouse-entity.service';
import { Vector2, Vector3 } from 'three';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable, noop } from 'rxjs';
import { RGBImage2 } from '../share/image';
import { map, tap } from 'rxjs/operators';
import { Plane2Model } from '../../ng3/model';
import { BoundingBox2FromCenterSize } from '../../ng3/share/boundingbox2';
import { Ng3MosueWheelEvent } from '../../ng3/controls/mouse/mouse-canvas.service';

@Component({
  selector: 'app-image2d',
  templateUrl: './image2d.component.html',
  styleUrls: ['./image2d.component.css'],
})
export class Image2dComponent implements OnInit {
  model$: Observable<Plane2Model>;
  private imageSubject = new BehaviorSubject<Display2DProperty>({
    image: new RGBImage2(
      new Vector2(0, 0),
      new Vector2(10, 10),
      new Vector2(1, 1),
      new Uint8Array([255]),
      new Uint8Array([255]),
      new Uint8Array([255]),
    ),
    rotation: new Vector3(0, 0, 0),
  });
  image$ = this.imageSubject.asObservable();
  @Input()
  get image(): Display2DProperty {
    return this.imageSubject.value;
  }
  set image(s: Display2DProperty) {
    if (s === undefined || s === null) {
      throw Error('Can not set Display2DProperty with null');
    }
    this.imageSubject.next(s);
  }
  @Input() z = 0;

  // @Output() scroll = new EventEmitter<number>();
  @Output() scroll = new EventEmitter<Ng3MosueWheelEvent>();
  @Output() drag = new EventEmitter<EntityDragEvent>();
  constructor() {
    this.model$ = this.image$.pipe(
      map((image) => {
        return new Plane2Model(
          new BoundingBox2FromCenterSize(
            image.image.meta.center,
            image.image.meta.size,
          ),
          10,
          {
            r: new Uint8Array(image.image.r),
            g: new Uint8Array(image.image.g),
            b: new Uint8Array(image.image.b),
            shape: new Vector2(
              image.image.meta.shape.x,
              image.image.meta.shape.y,
            ),
          },
          image.rotation,
        );
      }),
    );
    this.model$.subscribe(noop, (e) => console.error(e));
  }
  onWheelEvent(e: Ng3MosueWheelEvent) {
    this.scroll.emit(e);
  }
  onDragEvent(d: EntityDragEvent) {
    this.drag.emit(d);
  }
  ngOnInit() {}
}
